var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getDbClass()},[_c(_vm.layoutComponent,{tag:"component",attrs:{"dbspec":_vm.dbspec,"dbdata":_vm.dbdata,"dark":_vm.dark},on:{"db-event":_vm.handleDbEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }